import type { ReactNode } from 'react';
import Container, { Row } from '../container/Container';
import Spacing from '../container/Spacing';
import { TextLabelLarge } from '../text/Texts';

import { useForm } from 'react-hook-form';
import CheckboxInput from './CheckboxInput';

type Props = {
	icon: ReactNode;
	id: string;
	name: string;
	value: string;
	onChange?: (checked: boolean) => void;
	checked?: boolean;
	disabled?: boolean;
};

const RowCheckboxInput = ({
	icon,
	name,
	id,
	value,
	onChange,
	checked = false,
	disabled = false,
}: Props) => {
	const { control } = useForm();

	const toggle = () => {
		if (disabled) return;
		if (onChange) {
			onChange(!checked);
		}
	};

	return (
		<button
			type="button"
			onClick={toggle}
			disabled={disabled}
			className="flex flex-row w-full justify-between h-[96px] cursor-pointer active:bg-surfaceDim hover:bg-surfaceDim focus-visible:outline-none focus-visible:bg-surfaceDim bg-surfaceBright rounded-[28px] p-[24px]"
			aria-label={name}
		>
			<label
				htmlFor={id}
				className="flex content-start items-center cursor-pointer"
			>
				<Row className="items-center h-auto border">
					{icon}
					<Spacing width="w-3" />
					<TextLabelLarge text={name} className="text-primary" />
				</Row>
			</label>
			<Container className="flex items-center w-auto">
				<CheckboxInput
					tabIndex={-1}
					id={id}
					text=""
					control={control}
					value={value}
					// onChange={onChange}
					checked={checked}
					disabled={disabled}
				/>
			</Container>
		</button>
	);
};

export default RowCheckboxInput;
